module.exports = __webpack_public_path__ + "media/images/icons/icons_small/22_photos-220af051dd748f9e28fdb937043c47ff.png";